/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Form_SubInputs */

const es_ab_form_sub = /** @type {(inputs: Ab_Form_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo básico para empezar. Menos de un minuto.`)
};

const gl_ab_form_sub = /** @type {(inputs: Ab_Form_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O básico para comezar. Menos dun minuto.`)
};

const en_ab_form_sub = /** @type {(inputs: Ab_Form_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The basics to get started. Under a minute.`)
};

/**
* | output |
* | --- |
* | "The basics to get started. Under a minute." |
*
* @param {Ab_Form_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_form_sub = /** @type {((inputs?: Ab_Form_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Form_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_form_sub(inputs)
	if (locale === "en") return en_ab_form_sub(inputs)
	return es_ab_form_sub(inputs)
});